import { users } from './resources/users'
import { shipments } from './resources/shipments'
import { orders } from './resources/orders'
import { containers } from './resources/containers'
import { customers } from './resources/customers'
import { publicContainer } from './resources/publicContainer'
import { settings } from './resources/settings'
import { products } from './resources/products'
import { companies } from './resources/companies'
import { certificates } from './resources/certificates'
import { customsDeclarations } from './resources/customsDeclarations'
import { declaredProducts } from './resources/declaredProducts'
import { conditionalItems } from './resources/conditionalItems'
import { audits } from './resources/audits'
import { expenseItems } from './resources/expenseItems'
import { issueVouchers } from './resources/issueVouchers'
import { congNo } from './resources/congNo'
import { tonKho } from './resources/tonKho'
import { thongBao } from './resources/thongBao'
import { giaVon } from './resources/giaVon'
import { nhomHang } from './resources/nhomHang'
import { nhomKhachHang } from './resources/nhomKhachHang'
import { khachHang } from './resources/khachHang'
import { nhaCungCap } from './resources/nhaCungCap'
import { bangGia } from './resources/bangGia'
import { diaChiNhanHang } from './resources/diaChiNhanHang'
import { thongTinXuatHoaDon } from './resources/thongTinXuatHoaDon'
import { phieuNhapKho } from './resources/phieuNhapKho'
import { phieuXuatKho } from './resources/phieuXuatKho'
import { datHang } from './resources/datHang'
import { hoaDon } from './resources/hoaDon'
import { kenhBan } from './resources/kenhBan'
import { datHangNcc } from './resources/datHangNcc'
import { phieuNhanHang } from './resources/phieuNhanHang'
import { traHang } from './resources/traHang'
import { yeuCauSuaChua } from './resources/yeuCauSuaChua'
import { kiemKe } from './resources/kiemKe'
import { danhMucThuKhac } from './resources/danhMucThuKhac'
import { donViTinh } from './resources/donViTinh'
import { thuongHieu } from './resources/thuongHieu'
import { phanLoaiSanPham } from './resources/phanLoaiSanPham'
import { thongTinVatHangHoa } from './resources/thongTinVatHangHoa'
import { thuocTinh } from './resources/thuocTinh'
import { viTri } from './resources/viTri'
import { diaChiLayHang } from './resources/diaChiLayHang'
import { chuyenHang } from './resources/chuyenHang'
import { soQuy } from './resources/soQuy'
import { taiKhoanQuy } from './resources/taiKhoanQuy'
import { mauIn } from './resources/mauIn'
import { yeuCauXuatHoaDon } from './resources/yeuCauXuatHoaDon'
import { baoCao } from './resources/baoCao'
import { vanHanh } from './resources/vanHanh'
import { loTrinh } from './resources/loTrinh'
import { testDataMenuI18n } from '@/modules/test-data/i18n/en'
import { uiTestMenuI18n } from '@/modules/ui-test/i18n/en'
import { testModuleChiTietMenuI18n } from '@/modules/test-module-chitiet/i18n/en'
import { common } from './common'

export const en = {
  common,
  resources: {
    orders,
    users,
    shipments,
    containers,
    customers,
    publicContainer,
    settings,
    products,
    companies,
    certificates,
    customsDeclarations,
    declaredProducts,
    conditionalItems,
    audits,
    expenseItems,
    issueVouchers,
    congNo,
    tonKho,
    thongBao,
    giaVon,
    nhomHang,
    nhomKhachHang,
    khachHang,
    nhaCungCap,
    bangGia,
    diaChiNhanHang,
    thongTinXuatHoaDon,
    phieuNhapKho,
    phieuXuatKho,
    datHang,
    hoaDon,
    kenhBan,
    datHangNcc,
    phieuNhanHang,
    traHang,
    yeuCauSuaChua,
    kiemKe,
    danhMucThuKhac,
    donViTinh,
    thuongHieu,
    phanLoaiSanPham,
    thongTinVatHangHoa,
    thuocTinh,
    viTri,
    diaChiLayHang,
    chuyenHang,
    soQuy,
    taiKhoanQuy,
    mauIn,
    yeuCauXuatHoaDon,
    baoCao,
    vanHanh,
    loTrinh,
  },
  pages: {
    dashboard: {
      title: 'Business overview',
      subtitle: 'Today, {date}',
      recentOrders: 'Recent orders',
      recentInvoices: 'Recent invoices',
      monthLabel: '{month}/{year}',
      ky: {
        loai: {
          NGAY: 'Day',
          TUAN: 'Week',
          THANG: 'Month',
          QUY: 'Quarter',
          NAM: 'Year',
        },
        ngayLabel: '{day}/{month}/{year}',
        tuanLabel: 'Week {tuan}/{year} ({range})',
        thangLabel: '{month}/{year}',
        quyLabel: 'Q{quy}/{year}',
        namLabel: 'Year {year}',
      },
      actions: {
        sell: 'Sell',
        reports: 'Reports',
        viewAll: 'View all',
      },
      kpi: {
        revenue: 'Revenue',
        paid: 'Collected',
        invoiceCount: 'Invoices',
        avgInvoice: 'Avg. invoice value',
        vsPrevPeriod: 'vs. previous period',
        noPrevData: 'No data for previous period ({range})',
        today: 'Today: {value}',
        perDay: 'Avg/selling day: {value}',
        unpaid: 'Outstanding: {value}',
        paidRate: 'Collection rate {value}%',
        prevPeriodHint: 'Previous period: {value}',
      },
      chart: {
        title: 'Daily revenue',
        titleOnDay: 'Revenue for the day',
        titleInMonth: 'Revenue in the month',
        titleByMonth: 'Monthly revenue',
        revenue: 'Revenue',
        invoiceCount: 'Invoices',
        dayLabel: 'Day {day}',
        monthLabel: 'Month {month}',
        empty: 'No invoices in this period yet',
      },
      dtBang: {
        nvkdTitle: 'Revenue × Sales staff',
        chiNhanhTitle: 'Revenue × Branch',
        empty: 'No revenue in this period yet',
        loadFailed: 'Could not load revenue tables.',
        tongCong: 'Total',
        cols: {
          nvkd: 'Sales staff',
          chiNhanh: 'Branch',
          sl: 'Qty',
          dtThuan: 'Net revenue',
          giaVon: 'Cost',
          loiNhuan: 'Profit',
          lnTrenVon: '% markup',
          margin: '% margin',
          soKg: 'Kg',
          soKhoi: 'Volume (m³)',
          tyTrong: 'Share',
        },
      },
      topSale: {
        title: 'Top sellers',
        empty: 'No products sold in this period',
        loadFailed: 'Could not load top sellers.',
        soTopValue: 'Top {n}',
        tieuChi: {
          DOANH_THU: 'Revenue',
          SO_LUONG: 'Qty',
          LOI_NHUAN: 'Profit',
        },
        cols: {
          ma: 'SKU',
          ten: 'Product',
          sl: 'Qty',
          loiNhuan: 'Profit',
          lnTrenVon: '% markup',
          margin: '% margin',
          soKg: 'Kg',
          soKhoi: 'Volume (m³)',
          tyTrong: 'Share',
          metric: {
            DOANH_THU: 'Net revenue',
            SO_LUONG: 'Qty sold',
            LOI_NHUAN: 'Profit',
          },
        },
      },
      topMua: {
        title: 'Top buyers',
        empty: 'No customers purchased in this period',
        loadFailed: 'Could not load top buyers.',
        soTopValue: 'Top {n}',
        tieuChi: {
          DOANH_THU: 'Revenue',
          SO_LUONG: 'Qty',
          LOI_NHUAN: 'Profit',
        },
        cols: {
          ma: 'Customer code',
          ten: 'Customer',
          nvkd: 'Sales owner',
          soHd: 'Invoices',
          sl: 'Qty',
          loiNhuan: 'Profit',
          lnTrenVon: '% markup',
          margin: '% margin',
          soKg: 'Kg',
          soKhoi: 'Volume (m³)',
          tyTrong: 'Share',
          metric: {
            DOANH_THU: 'Net revenue',
            SO_LUONG: 'Qty bought',
            LOI_NHUAN: 'Profit',
          },
        },
      },
      overview: {
        title: 'System data',
        subtitle: 'Cumulative figures for the selected branch',
      },
      columns: {
        code: 'Code',
        customer: 'Customer',
        total: 'Total',
        status: 'Status',
        time: 'Time',
      },
      stats: {
        products: 'Products',
        stock: 'Stock: {count}',
        customers: 'Customers',
        suppliers: 'Suppliers',
        orders: 'Orders',
        invoices: 'Invoices',
        returns: 'Returns',
        goodsReceipts: 'Goods receipts',
        stocktakes: 'Stocktakes',
        inventoryValue: 'Inventory value',
      },
      salesReport: {
        title: 'Sales report',
        invoiceCount: 'Invoices',
        revenue: 'Revenue',
        date: 'Date',
      },
    },
    pos: {
      title: 'POS',
      searchPlaceholder: 'Search product code / name...',
      cart: 'Cart',
      items: 'items',
      stock: 'Stock',
      subtotal: 'Subtotal',
      checkout: 'Checkout',
      payment: 'Payment',
      paymentMethod: 'Method',
      customerPaid: 'Customer paid',
      change: 'Change',
      confirmPay: 'Confirm payment',
      emptyCart: 'Cart is empty',
      emptyCartHint: 'Select products or scan barcode',
      checkoutSuccess: 'Payment successful',
      productNotFound: 'Product not found',
      productInactive: 'Product is inactive',
      addedToCart: 'Added {name}',
      invalidPayment: 'Invalid payment amount',
      scanBarcode: 'Scan barcode',
      scannerError: 'Could not open camera',
      methods: {
        TIEN_MAT: 'Cash',
        THE: 'Card',
        VI: 'E-wallet',
        CHUYEN_KHOAN: 'Bank transfer',
      },
    },
    profile: {
      title: 'My account',
      subtitle: 'View and update your personal profile',
      editSection: 'Edit information',
    },
  },
  components: {
    menu: {
      home: 'Home',
      productsSection: 'Products',
      productMenuCatalog: 'Catalog',
      productMenuSetup: 'Setup',
      dataSection: 'Data',
      products: 'Products',
      phanLoaiSanPhamList: 'Product classification',
      thongTinVatHangHoaList: 'Product VAT info',
      sanPhamKhaiBao: 'Declared',
      transport: 'Transport',
      productCategories: 'Categories',
      priceGroups: 'Prices',
      declarationGroups: 'Declarations',
      operations: 'Ops',
      orders: 'Orders',
      shipments: 'Shipments',
      customers: 'Customers',
      system: 'System',
      warehouses: 'Warehouses',
      containers: 'Containers',
      expenseItems: 'Expense items',
      inventory: 'Inventory',
      phieuXuat: 'Issue vouchers',
      tonKho: 'Stock',
      congNo: 'Receivables',
      congNoKhachHang: 'Customer receivables',
      congNoThanhToan: 'Payments',
      congNoHoanTien: 'Refunds',
      congNoTheoDon: 'Receivables by invoice',
      congNoTheoDonChiTiet: 'Receivables by invoice line',
      giaVon: 'Costing',
      staffs: 'Staff',
      scanner: 'Scan',
      settings: 'Settings',
      companies: 'Companies',
      certificates: 'Certs',
      customsDeclarations: 'Customs',
      conditionalItems: 'Conditions',
      auditLogs: 'Audit',
      branchProject: 'Branch',
      switchBranch: 'Switch branch',
      nhomHangList: 'Item groups',
      partnersSection: 'Partners',
      customersSection: 'Customers',
      nhomKhachHangList: 'Customer groups',
      khachHangList: 'Customers',
      diaChiNhanHangList: 'Delivery info',
      thongTinXuatHoaDonList: 'Invoice info',
      suppliersSection: 'Suppliers',
      nhaCungCapList: 'Suppliers',
      deliverySection: 'Delivery',
      doiTacGiaoHangList: 'Delivery partners',
      bangGiaList: 'Price book setup',
      bangGiaHangHoaList: 'Product Price Books',
      phieuNhapKhoList: 'Stock-in',
      phieuXuatKhoList: 'Stock-out',
      dashboard: 'Overview',
      salesSection: 'Orders',
      banOnline: 'Online sales',
      donHangOnlineList: 'Online orders',
      donHangOnlineTiktok: 'TikTok Shop orders',
      donHangOnlineShopee: 'Shopee orders',
      hangHoaLienKetList: 'Linked products',
      doiSoatOnlineList: 'Reconciliation',
      gianHangOnlineList: 'Shops',
      thietLapKenhOnline: 'Channel settings',
      datHangList: 'Place order',
      hoaDonList: 'Invoices',
      maVanDonList: 'Tracking codes',
      hoaDonChiTietList: 'Invoice lines',
      yeuCauXuatHoaDonList: 'Invoice requests',
      xuatHuyList: 'Disposal',
      xuatTraNccList: 'Return to supplier',
      banHang: 'Sales',
      phanQuyen: 'Permissions',
      muaHang: 'Purchasing',
      sanXuat: 'Production',
      pos: 'POS',
      traHangList: 'Returns',
      datHangNccList: 'Supplier POs',
      phieuNhanHangList: 'Goods Receipts',
      yeuCauSuaChuaList: 'Repair requests',
      kiemKeList: 'Stock take',
      auditList: 'Audit log',
      logLoiHeThong: 'System error log (DEV)',
      danhMucThuKhacList: 'Other fee catalog',
      donViTinhList: 'Units of measure',
      thuongHieuList: 'Brands',
      thuocTinhList: 'Product attributes',
      viTriList: 'Warehouse locations',
      diaChiLayHangList: 'Pickup addresses',
      chuyenHangList: 'Stock transfer',
      inventorySection: 'Inventory',
      congQuyGroup: 'Treasury',
      soQuyGroup: 'Cash book',
      soQuyPhieuThu: 'Receipts',
      soQuyPhieuChi: 'Payments',
      soQuyBaoCao: 'Reports',
      soQuyTaiKhoanQuy: 'Cash accounts management',
      soQuyLoaiThuChi: 'Cashbook types',
      baoCaoSection: 'Reports',
      baoCaoBanHangGroup: 'Sales',
      baoCaoKhoGroup: 'Warehouse',
      baoCaoTongHop: 'Overview',
      baoCaoCuoiNgay: 'End of day',
      baoCaoBanHang: 'Sales',
      baoCaoDatHang: 'Orders',
      baoCaoHangHoa: 'Products',
      baoCaoKhachHang: 'Customers',
      baoCaoNhaCungCap: 'Suppliers',
      baoCaoNhanVien: 'Staff',
      baoCaoKenhBan: 'Sales channels',
      baoCaoTaiChinh: 'Finance',
      baoCaoPhanTich: 'Analysis',
      baoCaoDoanhThuLn: 'Revenue, profit',
      baoCaoTonKho: 'Inventory',
      baoCaoTopSale: 'Top sellers',
      baoCaoTopMua: 'Top buyers',
      baoCaoDaLuu: 'Saved reports',
      vanHanhSection: 'Warehouse',
      vanHanhDonHang: 'All orders',
      vanHanhXepNhat: 'Picking',
      vanHanhKiemTra: 'Checking',
      vanHanhDongGoi: 'Packing',
      vanHanhDieuPhoi: 'Dispatching',
      vanHanhGiaoHang: 'Delivery',
      banDoGiaoHang: 'Delivery map',
      thongBaoTrungTam: 'Notification center',
      caiDatThongBao: 'Notification settings',
      mauInHoaDon: 'Print templates',
      uiKit: 'Base UI',
      // ===== impl-b =====
      baoCaoChiTietDonHang: 'Order line reports',
      baoCaoDonVanHanh: 'By order (workflow)',
      ...testDataMenuI18n,
      ...uiTestMenuI18n,
      ...testModuleChiTietMenuI18n,
    },
    phieuTamTonKho: {
      headerLabel: 'Draft vouchers',
      headerLabelWithCount: 'Drafts ({count})',
      headerAria: '{count} unfinished draft vouchers — click to view list',
      panelTitle: '{count} unfinished draft vouchers',
      panelHint: 'Complete them so stock is deducted correctly. Click a code to open details.',
      viewAll: 'View all',
      andMore: '… and {count} more',
      createWarnTitle: 'Draft stocktakes still open',
      createWarnBody:
        'There are stocktake vouchers still in draft. Finish them (to adjust stock) before creating a new one.',
      createWarnTitleChuyenHang: 'Draft transfers still open',
      createWarnBodyChuyenHang:
        'There are transfer vouchers still in draft. Finish them (to adjust stock) before creating a new one.',
      createWarnTitleNhapKho: 'Draft goods receipts still open',
      createWarnBodyNhapKho:
        'There are goods receipt vouchers still in draft. Finish them (to add stock) before creating a new one.',
      createWarnTitleXuatKho: 'Draft goods issues still open',
      createWarnBodyXuatKho:
        'There are goods issue vouchers still in draft. Finish them (to deduct stock) before creating a new one.',
      createWarnContinue: 'Create anyway',
      createWarnCodesLabel: 'Draft vouchers:',
      inModalCount: '{count} open',
      chromeHint: '{count} draft vouchers left',
      createWarnHeaderHint:
        'The draft list also stays on the «Drafts» button in the header — finish them so stock stays correct.',
    },
  },
  auth: {
    login: 'Login',
    logout: 'Logout',
    register: 'Register',
    username: 'Username',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    forgotPassword: 'Forgot Password?',
    resetPassword: 'Reset Password',
    changePassword: 'Change Password',
    email: 'Email',
    rememberMe: 'Remember Me',
  },
  navigation: {
    home: 'Home',
    orders: 'Orders',
    shipments: 'Shipments',
    customers: 'Customers',
    warehouses: 'Warehouses',
    containers: 'Containers',
    staffs: 'Staffs',
    settings: 'Settings',
  },
  validation: {
    required: 'This field is required',
    email: 'Invalid email format',
    minLength: 'Minimum {min} characters',
    maxLength: 'Maximum {max} characters',
    numeric: 'Only numbers allowed',
  },
  messages: {
    success: 'Success',
    error: 'An error occurred',
    warning: 'Warning',
    info: 'Information',
    loading: 'Loading...',
    noData: 'No data available',
    confirmDelete: 'Are you sure you want to delete this?',
  },
}
